import React from 'react'
import "./Card.css"

function Card({ image, text }) {
  return (
    <>
      <div className="home-card">
        <img src={image} alt={text} className="home-card-image" />
        <div className="home-card-text">{text}</div>
      </div>
    </>
  )
}

export default Card